export default __webpack_public_path__ + "media/images/lp/howto-sp-b2d7c50ce21e62559ad4569af529f292.jpg";